import { Link, useParams, useLocation } from "react-router-dom";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./SurveyFinish.module.css";
import PageLayout from "../PageLayout";

export default function SurveyFinish() {
    const { id } = useParams();
    const { t } = useTranslation();
    const location = useLocation();
    // Determine which RID to display: prefer user-provided RID (stored in sessionStorage),
    // otherwise fall back to RID passed from API/state or URL.
    const rid = useMemo(() => {
        const qs = new URLSearchParams(location.search);
        const fromUrl = (qs.get("rid") || "").trim();
        const fromState = ((location.state && location.state.rid) || "").trim();
        let fromStorage = "";
        try {
            fromStorage = (sessionStorage.getItem(`survey:${id}:rid`) || "").trim();
        } catch { }
        return fromStorage || fromState || fromUrl || null;
    }, [id, location.search, location.state]);

    const [copied, setCopied] = useState(false);
    const [email, setEmail] = useState("");
    const [emailMsg, setEmailMsg] = useState(null);
    const [busy, setBusy] = useState(false);

    const emailIsValid = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    const canSubmitEmail = emailIsValid(email) && !busy;


    function copyToClipboard(text) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            });
        } else {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.style.position = 'absolute';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    }

    async function onSubmitEmail(e) {
        e.preventDefault();
        if (!canSubmitEmail) return;
        setBusy(true);
        setEmailMsg(null);
        try {
            // TODO: wysyłanie maila do zapisania
            setEmailMsg({ type: 'ok', text: t('survey.finish.emailSaved') });
            setEmail("");
        } catch (err) {
            setEmailMsg({ type: 'err', text: err?.message || t('common.error') });
        } finally {
            setBusy(false);
        }
    }

    return (
        <PageLayout>
            <div className={styles.section}>
                <h1>{t("survey.finish.title")}</h1>
                <p>{t("survey.finish.description")}</p>

                <div className={styles.infoBox}>
                    <h2>{t("survey.finish.infoBox.title")}</h2>
                    <p>{t("survey.finish.infoBox.description")}</p>
                    {rid && (
                        <div className={styles.responseId}>
                            <div className={styles.ridLabel}>{t("survey.finish.responseId")}</div>
                            <button
                                type="button"
                                className={`${styles.idBadge} ${copied ? styles.idBadgeCopied : ''}`}
                                onClick={() => copyToClipboard(rid)}
                            >
                                <span className={`${styles.ridText} ${copied ? styles.invisible : ''}`}>{rid}</span>
                                {copied && (
                                    <span className={styles.copiedText}>
                                        {t("survey.finish.copied", { defaultValue: "Copied!" })}
                                    </span>
                                )}
                            </button>
                            <p>{t("survey.finish.infoBox.description2")}</p>
                        </div>
                    )}

                    {/* <form className={styles.emailField} onSubmit={onSubmitEmail} noValidate>
                        <input
                            id="email"
                            type="email"
                            autoComplete="email"
                            placeholder={t("auth.email")}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={styles.emailInput}
                            aria-invalid={email.length > 0 && !emailIsValid(email)}
                        />
                        <button className={styles.btn} type="submit" disabled={!canSubmitEmail}>
                            {busy ? t('common.saving') : t('auth.registerEmail')}
                        </button>
                    </form>
                    {emailMsg && (
                        <p className={emailMsg.type === 'ok' ? styles.msgOk : styles.msgErr}>{emailMsg.text}</p>
                    )} */}
                </div>

                <div className={styles.actions}>
                    <Link to={`/surveys/`} className={styles.btn}>
                        {t("survey.finish.backToSurveys")}
                    </Link>
                    <Link to={`/surveys/${id}`} className={styles.btn}>
                        {t("survey.finish.fillAgain")}
                    </Link>
                </div>
            </div>
        </PageLayout>
    );
}
